import styled from '@emotion/styled';

export const Place = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 0 30px;
`;